import axios, { AxiosRequestConfig, Method } from "axios";

// const mode = process.env.REACT_APP_MODE;
const baseURL = process.env.REACT_APP_BASE_API_URL;

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    // if (mode) {
    //   config.headers['X-Mode'] = mode;
    // }
    // Prefer the impersonation token when present so all requests run as
    // the impersonated brand owner. Falls back to the regular access token.
    const token =
      sessionStorage.getItem("impersonation") ??
      sessionStorage.getItem("access");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token.replace(/['"]+/g, "")}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// If an impersonation token expires or is revoked mid-session, drop it
// silently so the next request falls back to the superuser's own token.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 401 &&
      sessionStorage.getItem("impersonation")
    ) {
      sessionStorage.removeItem("impersonation");
      sessionStorage.removeItem("impersonation_meta");
      window.location.assign("/dashboard");
    }
    return Promise.reject(error);
  }
);

export function makeRequest(
  method: Method = "get",
  endpoint: string,
  data: object = {},
  config: AxiosRequestConfig = {}
): Promise<any> {
  const options: AxiosRequestConfig = {
    url: endpoint,
    method,
    ...config,
  };
  if (["post", "put", "patch"].includes(method.toLowerCase())) {
    options.data = data;
  } else if (method.toLowerCase() === "get" && Object.keys(data).length > 0) {
    options.params = data;
  }

  return api(options).then((res) => res.data);
}

export default api;
